/**
 * 投稿に付けられる絵文字。
 *
 * 自由入力にしないのは、肌色・ZWJ 連結・異体字で「同じ見た目の別の文字列」が生まれ、
 * 集計が分裂するため。ここが唯一の出所で、DB の CHECK 制約には書かない
 * (書くと絵文字を足すたびにマイグレーションが要る)。
 *
 * `name` は GitHub / Slack の shortcode に合わせている。並びがそのまま画面の並び順。
 * 古い端末で豆腐にならないよう、Unicode 11 (2018) までのものだけを選んでいる。
 */
export const REACTIONS = [
  { name: "thumbsup", emoji: "👍", label: "いいね" },
  { name: "clap", emoji: "👏", label: "お見事" },
  { name: "heart", emoji: "❤️", label: "好き" },
  { name: "heart_eyes_cat", emoji: "😻", label: "かわいい" },
  { name: "paw_prints", emoji: "🐾", label: "見たよ" },
  { name: "joy", emoji: "😂", label: "笑った" },
  { name: "cry", emoji: "😢", label: "つらい" },
  { name: "scream", emoji: "😱", label: "ぎょっとした" },
  { name: "open_mouth", emoji: "😮", label: "へえ" },
  { name: "thinking", emoji: "🤔", label: "うーん" },
  { name: "bulb", emoji: "💡", label: "なるほど" },
  { name: "fire", emoji: "🔥", label: "すごい" },
  { name: "sparkles", emoji: "✨", label: "いい感じ" },
  { name: "tada", emoji: "🎉", label: "おめでとう" },
  { name: "pray", emoji: "🙏", label: "助かった" },
] as const;

export type ReactionName = (typeof REACTIONS)[number]["name"];

export const REACTION_NAMES: readonly ReactionName[] = REACTIONS.map((item) => item.name);

/** 並び順を保ったまま名前で引く。 */
const byName = new Map(REACTIONS.map((item) => [item.name as string, item]));

export function reactionOf(name: string): (typeof REACTIONS)[number] | undefined {
  return byName.get(name);
}
